
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';

  export default defineComponent({
    name: 'registration-reasons-listing',
    components: {
      Datatable,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => (te(text) ? t(text) : text);

      onMounted(async () => {
        await store.dispatch(Actions.GET_REGISTRATION_REASONS);
        setCurrentPageBreadcrumbs(translate('registrationReasonsListing'), [
          translate('assets'),
        ]);
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_REGISTRATION_REASONS_STORE);
      });

      await store.dispatch(Actions.GET_REGISTRATION_REASONS);
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('idColumn'),
          key: 'id',
          sortable: true,
        },
        {
          name: translate('titleEn'),
          key: 'titleEn',
          sortable: true,
        },
        {
          name: translate('titleAr'),
          key: 'titleAr',
          sortable: true,
        },
        {
          name: translate('status'),
          key: 'isActive',
          sortable: true,
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);

      const toggleStatus = async (reason) => {
        const confirmText = reason.isActive
          ? 'confirmInActive'
          : 'confirmActive';
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          text: translate(confirmText),
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_REGISTRATION_REASON, reason.id);
          await store.dispatch(Actions.GET_REGISTRATION_REASONS);
          loading.value = false;

          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              confirmButtonText: translate('tryAgainExcl'),
              customClass: { confirmButton: 'btn fw-bold btn-light-danger' },
            });
          } else {
            const successMsg = reason.isActive
              ? 'SUCCESSFULLY_INACTIVATED'
              : 'SUCCESSFULLY_ACTIVEATED';
            Swal.fire({
              text: translate(successMsg),
              icon: 'success',
              confirmButtonText: translate('ok'),
              customClass: { confirmButton: 'btn btn-light-primary' },
            });
          }
        }
      };

      const editReason = (id) => {
        router.push({ name: 'registration-reasons-editing', params: { id } });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (page) => {
        loading.value = true;
        await store.dispatch(
          Actions.UPDATE_REGISTRATION_REASON_CURRENT_PAGE,
          page
        );
        await store.dispatch(Actions.GET_REGISTRATION_REASONS);
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        tableData: computed(() => store.getters.reasonsList),
        totalItems: computed(() => store.getters.registrationReasonsListCount),
        tableHeader,
        toggleStatus,
        translate,
        editReason,
        goTo,
        pageChanged,
        loading,
        can,
      };
    },
  });
